import React, { useEffect, useState } from 'react';

const AboutMe = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const technologiesSection = document.getElementById('about-me');
      const windowHeight = window.innerHeight;
      const triggerPosition = windowHeight * 0.8;
      
      if (technologiesSection.offsetTop < (window.scrollY + triggerPosition)) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); 
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="about-me" className={`about ${isVisible ? 'slideup-anim' : ''}`}>
      <h2 className="title">À Propos de Moi</h2>
      <div className="about__inner">
        <div className={`about__prez ${isVisible ? 'slidein-anim' : ''}`}>
          <p>Bonjour ! Je suis <strong>Romain KORDALSKI</strong>, actuellement en formation de développeur web full stack chez <a href="https://oclock.io/">O'clock</a></p>
          <p>Ma passion pour la programmation remonte à toujours, et j'ai trouvé ma voie dans le monde du développement web. </p>
          <p>Chaque ligne de code que j'écris est une opportunité de concrétiser mes idées et de donner vie à des projets créatifs.</p>
          <p>Parcourez mon portfolio pour découvrir mes réalisations et n'hésitez pas à me contacter pour discuter.</p>
          <p>Je vous souhaite une bonne visite.</p>
        </div>
        <div className={`picture-wrapper ${isVisible ? 'slidein-anim' : ''}`} style={{ opacity: isVisible ? 1 : 0 }}>
          <div className="picture">
            <div className="picture__img">
            <div className="imgmy">
            <img
              src="/image2.jpeg"
              alt="kordalski romain"
              className="img-fluid myimg__photo"
            />
          </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
